// extracted by mini-css-extract-plugin
export default {"wrapper":"CallToActionGroup_wrapper__qBaZy"};